/* LYNX Cannabis — Unit Pricing & Default Variant Script
 * Handles:
 * 1. Collection/landing pages: shows "nuo €X,XX/but." for drinks, "€X,XX/g" for flowers
 * 2. Product pages: auto-selects 12 vnt., shows dynamic €/but. or €/g
 */
(function() {
  'use strict';

  var cache = {};

  function isDrink(title) {
    return /lynxmonadas|LYNXMONADAS|Lynxmonadas/i.test(title);
  }

  function parseBottles(variantTitle) {
    var m = variantTitle.match(/(\d+)\s*vnt/i);
    return m ? parseInt(m[1]) : 1;
  }

  function fmtPrice(n) {
    return '€' + n.toFixed(2).replace('.', ',');
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(d) { cache[handle] = d.product; return d.product; })
      .catch(function() { return null; });
  }

  /* ── Collection / Landing page ── */
  function processCards() {
    var seen = {};
    var cards = document.querySelectorAll(
      '.card, .product-card, .featured-product, [class*="product-grid"] > *'
    );
    if (!cards.length) return;

    cards.forEach(function(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.href.match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var handle = m[1];

      // avoid processing same card twice
      if (card.dataset.lcUp) return;
      card.dataset.lcUp = '1';

      fetchProduct(handle).then(function(product) {
        if (!product) return;

        var unitEl = card.querySelector('.unit-price');
        if (!unitEl) {
          // create one if missing
          var priceBox = card.querySelector('.price__container, .price, [class*="price"]');
          if (!priceBox) return;
          unitEl = document.createElement('small');
          unitEl.className = 'unit-price caption';
          priceBox.appendChild(unitEl);
        }

        if (isDrink(product.title)) {
          // Calculate cheapest per-bottle price across all variants
          var cheapest = Infinity;
          product.variants.forEach(function(v) {
            var b = parseBottles(v.title);
            if (b > 0) {
              var ppb = parseFloat(v.price) / b;
              if (ppb < cheapest) cheapest = ppb;
            }
          });
          if (cheapest === Infinity) return;
          unitEl.innerHTML = 'nuo ' + fmtPrice(cheapest) + '/but.';
          unitEl.classList.remove('hidden');
          unitEl.style.display = '';
        } else {
          // Flowers: price per gram
          var v0 = product.variants[0];
          var grams = v0.grams || v0.weight || 0;
          if (grams <= 0) return;
          var ppg = parseFloat(v0.price) / grams;
          unitEl.innerHTML = fmtPrice(ppg) + '/g';
          unitEl.classList.remove('hidden');
          unitEl.style.display = '';
        }
      });
    });
  }

  /* ── Product page ── */
  function processProductPage() {
    var pm = window.location.pathname.match(/\/products\/([^?#\/]+)/);
    if (!pm) return;
    var handle = pm[1];

    fetchProduct(handle).then(function(product) {
      if (!product) return;

      // ── Auto-select 12 vnt. for drinks ──
      if (isDrink(product.title) && !window.location.search.includes('variant=')) {
        setTimeout(function() { autoSelect12(product); }, 600);
      }

      // ── Inject/update unit price ──
      var unitEls = document.querySelectorAll('.unit-price');
      // Find the main product unit-price (not in recommended section)
      var mainUnit = null;
      unitEls.forEach(function(el) {
        var parent = el.closest('.product, .product-single, [class*="main-product"], section');
        if (parent && !parent.querySelector('.card')) {
          mainUnit = el;
        }
      });
      if (!mainUnit && unitEls.length > 0) mainUnit = unitEls[0];

      if (mainUnit) {
        updateProductUnitPrice(mainUnit, product);
        // Listen for variant changes
        observeVariantChange(mainUnit, product);
      }
    });
  }

  function autoSelect12(product) {
    // Try <select> element first
    var selects = document.querySelectorAll('select');
    selects.forEach(function(sel) {
      var opts = sel.options;
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].text.indexOf('12') !== -1 && opts[i].text.indexOf('vnt') !== -1) {
          if (sel.selectedIndex !== i) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
    });

    // Try radio buttons / custom buttons
    var btns = document.querySelectorAll(
      'input[type="radio"], [data-option-value], button[data-value]'
    );
    btns.forEach(function(btn) {
      var txt = btn.value || btn.dataset.value || btn.textContent || '';
      if (txt.indexOf('12') !== -1 && txt.indexOf('vnt') !== -1) {
        btn.click();
      }
    });
  }

  function updateProductUnitPrice(unitEl, product) {
    // Determine current variant from URL or selected option
    var variantId = null;
    var urlParams = new URLSearchParams(window.location.search);
    variantId = urlParams.get('variant');

    var currentVariant = null;
    if (variantId) {
      product.variants.forEach(function(v) {
        if (String(v.id) === String(variantId)) currentVariant = v;
      });
    }
    if (!currentVariant) currentVariant = product.variants[0];

    if (isDrink(product.title)) {
      var bottles = parseBottles(currentVariant.title);
      if (bottles > 0) {
        var ppb = parseFloat(currentVariant.price) / bottles;
        unitEl.innerHTML = fmtPrice(ppb) + '/but.';
        unitEl.classList.remove('hidden');
        unitEl.style.display = '';
      }
    } else {
      var grams = currentVariant.grams || currentVariant.weight || 0;
      if (grams > 0) {
        var ppg = parseFloat(currentVariant.price) / grams;
        unitEl.innerHTML = fmtPrice(ppg) + '/g';
        unitEl.classList.remove('hidden');
        unitEl.style.display = '';
      }
    }
  }

  function observeVariantChange(unitEl, product) {
    // Watch URL changes (variant=...)
    var lastVariant = '';
    setInterval(function() {
      var params = new URLSearchParams(window.location.search);
      var vid = params.get('variant');
      if (vid && vid !== lastVariant) {
        lastVariant = vid;
        var v = null;
        product.variants.forEach(function(vr) {
          if (String(vr.id) === String(vid)) v = vr;
        });
        if (!v) return;

        if (isDrink(product.title)) {
          var b = parseBottles(v.title);
          if (b > 0) {
            unitEl.innerHTML = fmtPrice(parseFloat(v.price) / b) + '/but.';
            unitEl.classList.remove('hidden');
            unitEl.style.display = '';
          }
        } else {
          var g = v.grams || v.weight || 0;
          if (g > 0) {
            unitEl.innerHTML = fmtPrice(parseFloat(v.price) / g) + '/g';
            unitEl.classList.remove('hidden');
            unitEl.style.display = '';
          }
        }
      }
    }, 300);

    // Also watch <select> changes
    document.querySelectorAll('select').forEach(function(sel) {
      sel.addEventListener('change', function() {
        setTimeout(function() {
          updateProductUnitPrice(unitEl, product);
        }, 200);
      });
    });
  }

  /* ── Init ── */
  function init() {
    processCards();
    processProductPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on AJAX page loads (Shopify sections)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(processCards, 500);
  });

  // Re-run when new content appears (infinite scroll, etc.)
  var observer = new MutationObserver(function(mutations) {
    var shouldProcess = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length > 0) shouldProcess = true;
    });
    if (shouldProcess) {
      setTimeout(processCards, 300);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
